import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { cssCLSocials, StyledLinkList, StyledLinkListItem } from "@/components/List/LinkList/StyledLinkList";
import { StyledList, StyledListItem } from "@/components/List/StyledList";
import { StyledSuccessOverlay } from "@/forms/SuccessOverlay/StyledSuccessOverlay";
import { Row } from "@/styles/utils/StyledGrid";
import { breakpoints, colors } from "@/styles/utils/vars";
import { ButtonBase } from "@/ui/Button/StyledButton";
import { cssIcon } from "@/ui/Icon";
import { StyledLinkBase } from "@/ui/Link/StyledLink";
import { StyledNav } from "@/ui/Navigation/StyledNavigation";
import { getTypographyBase, Paragraph12, Span } from "@/ui/Typography/Typography";
export const cssOverrideListItem = "cssOverrideListItem_c1xywfn3";
export const RowListGroup = /*#__PURE__*/styled(Row)({
  name: "RowListGroup",
  class: "RowListGroup_r1mf7gh6"
});
export const ListGroupTitle = /*#__PURE__*/styled(Paragraph12)({
  name: "ListGroupTitle",
  class: "ListGroupTitle_l7mg30y"
});
export const ListGroup = /*#__PURE__*/styled('div')({
  name: "ListGroup",
  class: "ListGroup_liakovl"
});
export const PaymentIcons = /*#__PURE__*/styled('div')({
  name: "PaymentIcons",
  class: "PaymentIcons_pqdwrk"
});
export const PaymentItem = /*#__PURE__*/styled('div')({
  name: "PaymentItem",
  class: "PaymentItem_p4xakpd"
});
export const PaymentsGroupTitle = /*#__PURE__*/styled(ListGroupTitle)({
  name: "PaymentsGroupTitle",
  class: "PaymentsGroupTitle_p1tp6jqm"
});
export const FooterUnder = /*#__PURE__*/styled('div')({
  name: "FooterUnder",
  class: "FooterUnder_ftvf038"
});
export const FooterMain = /*#__PURE__*/styled('div')({
  name: "FooterMain",
  class: "FooterMain_fls8tc3"
});
export const FooterContactList = /*#__PURE__*/styled('div')({
  name: "FooterContactList",
  class: "FooterContactList_f1ivxlnf"
});
export const FooterMainList = /*#__PURE__*/styled('div')({
  name: "FooterMainList",
  class: "FooterMainList_f1yaugxy"
});
export const FooterContent = /*#__PURE__*/styled('div')({
  name: "FooterContent",
  class: "FooterContent_fz2nsq1"
});
export const StyledFooter = /*#__PURE__*/styled('footer')({
  name: "StyledFooter",
  class: "StyledFooter_sccnkwy"
});

require("./StyledFooter.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledFooter.tsx");